import createCache from '@emotion/cache';

/**
 * Creates an Emotion cache configured for Hotjar compatibility.
 *
 * By default, Emotion uses insertRule() to inject styles into the CSSOM,
 * which Hotjar cannot capture in session recordings. This causes UI to appear
 * broken in recordings even though it works correctly for users.
 *
 * Setting speedy: false forces Emotion to inject styles as <style> tags in the DOM,
 * which Hotjar can capture and replay correctly in recordings.
 *
 * This affects ALL Emotion-based styling including:
 * - styled() components from @emotion/styled
 * - MUI's sx prop
 * - MUI's styled() API
 * - Theme-based dynamic styles
 * - Any runtime-generated styles
 *
 * Performance Impact:
 * - Build: No impact on bundle size or build time
 * - Runtime: +20-50ms initial page load, slightly higher memory usage
 * - Trade-off: Accurate Hotjar recordings vs. minor performance cost
 *
 * Note: We always use speedy: false in production to ensure Hotjar recordings
 * work correctly. The performance impact is minimal compared to the value of
 * accurate session recordings for debugging and UX analysis.
 */
export const createEmotionCache = () => {
  return createCache({
    key: 'css',
    // Force Emotion to use DOM injection instead of CSSOM insertRule()
    // This makes styles visible to Hotjar's session recorder
    speedy: false,
  });
};
